import React, { useState } from "react";
import styles from "./CreateFeePlan.module.css";
import { useNavigate } from "react-router-dom";
import HeadingAndData from "../../components/HeadingAndData/HeadingAndData";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import CalendarInput from "../../components/CalendarInput/CalendarInput";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import ToClose from "../../components/ToClose/ToClose";
import { IoCalendarClearOutline } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { closeModal, openModal } from "../../redux/slices/modalSlice";
import { div } from "framer-motion/client";

const CreateFeePlan = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    fromDate: "",
    toDate: "",
    program: "",
    label: "",
    invoicePeriod: "",
    billingDetails: "",
    invoiceDue: "",
    schoolNote: "",
    parentNote: "",
    credit: false,
    generateFirst: false,
  });

  const handelCancel = () => {
    dispatch(closeModal() );
  };
  const handleChange = (field) => (e) => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleDateChange = (field) => (date) => {
    setFormData((prev) => ({ ...prev, [field]: date }));
  };

  const handleNext = () => {
    console.log("Submitted:", formData);
    dispatch(openModal("createInvoice"));
  };

  return (
    <div className={styles.CreateFeePlan}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <HeadingAndIcon
            icon={<IoCalendarClearOutline />}
            heading="Create Plan Schedule"
          />
          <ToClose onClose={() => dispatch(closeModal())} />
        </div>

        <div className={styles.content}>
          <div className={styles.row}>
            <HeadingAndData
              label="Fee Plan Name"
              name="name"
              placeholder="Enter name"
              value={formData.name}
              onChange={handleChange("name")}
              required
            />
            <CalendarInput
              fieldLabel="Fee plan period"
              value={formData.fromDate}
              onChange={handleDateChange("fromDate")}
              required
            />
            <CalendarInput
              fieldLabel="Fee plan period"
              value={formData.toDate}
              onChange={handleDateChange("toDate")}
              required
            />
          </div>

          <div className={styles.row}>
            <HeadingAndDropDown
              label="Program"
              name="program"
              value={formData.program}
              onChange={handleChange("program")}
              options={[{ label: "Program 1", value: "1" }]}
            />
            <HeadingAndDropDown
              label="Labels"
              name="label"
              value={formData.label}
              onChange={handleChange("label")}
              options={[{ label: "Label A", value: "a" }]}
            />
            <HeadingAndDropDown
              label="Invoice period"
              name="invoicePeriod"
              value={formData.invoicePeriod}
              onChange={handleChange("invoicePeriod")}
              required
              options={[{ label: "Monthly", value: "monthly" }]}
            />
          </div>

          <div className={styles.row}>
            <HeadingAndDropDown
              label="Billing Details"
              name="billingDetails"
              value={formData.billingDetails}
              onChange={handleChange("billingDetails")}
              required
              options={[{ label: "Invoice generation day", value: "day" }]}
            />
            <HeadingAndDropDown
              label="Invoice due after"
              name="invoiceDue"
              value={formData.invoiceDue}
              onChange={handleChange("invoiceDue")}
              required
              options={[{ label: "5 days", value: "5" }]}
            />

            <label className={styles.sendWrapper}>
              <input
                type="checkbox"
                checked={formData.sendToParent}
                onChange={handleChange("sendToParent")}
              />
              <span>Send invoice via mail to parent</span>
            </label>
          </div>

          <label className={styles.billingLabel}>Billing Period</label>
          <div className={styles.billingDetails}>
            <p>Next Invoice Details</p>
            <p>
              Your invoice will be generated on 07/12/2025 due on 13/12/2025 for
              the period of 01/11/2025 to 30/11/2025
            </p>
          </div>

          <label className={styles.billingLabel}>
            School notes (not for parents)
          </label>
          <textarea
            className={styles.textarea}
            placeholder="Describe here ..."
            value={formData.schoolNote}
            onChange={handleChange("schoolNote")}
          />

          <label className={styles.billingLabel}>
            Parent notes (also for parents)
          </label>
          <textarea
            className={styles.textarea}
            placeholder="Describe here ..."
            value={formData.parentNote}
            onChange={handleChange("parentNote")}
          />

          <div className={styles.checkboxGroup}>
            <label>
              <input
                type="checkbox"
                checked={formData.credit}
                onChange={handleChange("credit")}
              />
              Settle with Credit
            </label>
            <label>
              <input
                type="checkbox"
                checked={formData.generateFirst}
                onChange={handleChange("generateFirst")}
              />
              Generate first invoice on the joining date for ongoing billing
              period if a student joins after invoice generation date.
            </label>
          </div>

          <div className={styles.actions}>
            <SaveAndCancel
              onCancel={handelCancel}
              onSave={handleNext}
              saveLabel="Next"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateFeePlan;
